import * as LucideIcons from 'lucide-react';

// 🎯 أيقونات التطبيقات الكستم مخزّنة كاسم نصي (icon_name) في الداتابيز لأنها
// بتتعرّف وقت التشغيل بمعرفة الأدمن - مش import ثابت وقت الـ build زي باقي
// الموديولز. الدالة دي بتحول الاسم لكومبوننت حقيقي، وترجع أيقونة افتراضية
// لو الاسم غلط أو مش موجود في lucide-react.
export const resolveIcon = (name, fallback = LucideIcons.Cpu) => {
  if (!name) return fallback;
  return LucideIcons[name] || fallback;
};

// 🎯 كل أسماء الأيقونات الحقيقية المتاحة في lucide-react - بنستبعد الـ
// exports اللي مش أيقونات فعلية (زي createLucideIcon والـ icons map نفسها)
// عشان نقدر نعرض بيكر بيدور على أي أيقونة في المكتبة، مش شورت-ليست مختارة يدويًا
const NON_ICON_EXPORTS = new Set(['createLucideIcon', 'icons', 'default']);
export const ALL_ICON_NAMES = Object.keys(LucideIcons)
  .filter((name) => !NON_ICON_EXPORTS.has(name) && /^[A-Z]/.test(name))
  .sort();

export default resolveIcon;
